export enum NotificacaoTipoEnum {
   MENSAGEM_COMUM = 'COMUM',
   MENSAGEM_PRIORITARIA = 'PRIORITARIA',
   CARGA = 'CARGA',
}

export enum NotificacaoStatus {
   INFO = 'info',
   SUCESSO = 'success',
   AVISO = 'warning',
   ERRO = 'danger',
}

